export default "__VITE_ASSET__D9GxU5fw__"